import React from 'react';

import { className } from 'aplazame-design-system';

export default function SpacerSection({
    showInDesktop,
    showInMobile
}) {
    return showInDesktop || showInMobile ? (
        <div {...className([
            showInMobile ? 'pt-10' : '',
            showInDesktop && !showInMobile ? 'pt-lg-10' : '',
            !showInDesktop && showInMobile ? 'pt-lg-0' : ''
        ].join(' '))} />
    ) : null;
}